// import {
// 	createStore,
// 	applyMiddleware
// } from "redux";

// import {
// 	persistReducer,
// 	persistStore
// } from 'redux-persist';

// import { rootReducer } from '../reducers/index';
// import { encryptTransform } from 'redux-persist-transform-encrypt';
// import { BlackListData } from "../constants/store";

// import thunk from "redux-thunk";
// import storage from 'redux-persist/lib/storage';

// const persistConfig = {
// 	key: 'root',
// 	storage,
// 	transforms: [
// 		encryptTransform({
// 			secretKey: 'x898R)_q>2f_iV3Q5.,(8DF',
// 		}),
// 	],
// 	blacklist: BlackListData
// }

// const persistedReducer = persistReducer(persistConfig, rootReducer);
// const store = createStore(persistedReducer, applyMiddleware(thunk));
// const persistor = persistStore(store);

// persistor.persist();

// export { store, persistor }


import {
	createStore,
	applyMiddleware,
	compose
} from "redux";

import {
	persistReducer,
	persistStore,
	// FLUSH,
	// REHYDRATE,
	// PAUSE,
	// PERSIST,
	// PURGE,
	// REGISTER
} from 'redux-persist';

import { rootReducer } from '../reducers/index';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { BlackListData } from "../constants/store";

import thunk from "redux-thunk";
import storage from 'redux-persist/lib/storage';

// Import composeWithDevTools
import { composeWithDevTools } from 'redux-devtools-extension';

const persistConfig = {
	key: 'root',
	storage,
	// debug: true,
	transforms: [
		encryptTransform({
			secretKey: 'x898R)_q>2f_iV3Q5.,(8DF',
			onError: (error) => {
				console.log(error)
			}
		}),
	],
	blacklist: BlackListData
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create an enhancer for your middleware
const middlewareEnhancer = applyMiddleware(thunk);

// Conditionally apply Redux DevTools in development
const composedEnhancers = process.env.NODE_ENV === 'development'
	? composeWithDevTools(middlewareEnhancer)
	: compose(middlewareEnhancer);

// Create store with initial state
const store = createStore(
	persistedReducer,
	undefined, // No initial state
	composedEnhancers
);

// Create persistor
const persistor = persistStore(store);

export { store, persistor };